import Backbone from 'backbone';
import MenuButtonView from './menuButtonView';

export default Backbone.View.extend({
  addToCollection(model, fragmentEl) {
    var fragment = fragmentEl || null;
    var viewObject = MenuButtonView;

    var view = new viewObject({
      model
    });
    var rendered = view.render().el;

    if (fragment) {
      fragment.appendChild(rendered);
    } else {
      this.$el.append(rendered);
    }
    return rendered;
  },

  render() {
    var fragment = document.createDocumentFragment();
    this.$el.empty();

    this.collection.each(function(model) {
      this.addToCollection(model, fragment);
    }, this);

    this.$el.append(fragment);
    this.$el.addClass('buttons_group');
    return this;
  }
});
